var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2zm9.536 18.28a2 2 0 1 0-3.072-2.56l-8.6 10.318-4.45-4.452a2 2 0 0 0-2.828 2.828l6 6a2 2 0 0 0 2.95-.134l10-12z",
    fill: "#5DB617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckSuccess);
export default __webpack_public_path__ + "static/media/green-check-success.3e8e056baf973866be6b5d6aaf9be58c.svg";
export { ForwardRef as ReactComponent };